import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function GuestCountModal({ open, onOpenChange, table, onConfirm, isLoading }) {
  const [guests, setGuests] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    console.log("[GuestCountModal] open prop changed to:", open, "table:", table);
    if (open) {
      console.log("[GuestCountModal] Modal is opening");
      setGuests("");
      setError("");
    } else {
      console.log("[GuestCountModal] Modal is closing");
    }
  }, [open]);

  const handleConfirm = async () => {
    const guestCount = parseInt(guests, 10);
    if (!guests.trim() || isNaN(guestCount) || guestCount < 1) {
      setError("Cantidad de personas debe ser >= 1");
      return;
    }
    const success = await onConfirm(guestCount);
    if (success !== false) {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => onOpenChange(false)}>
      <DialogContent className="sm:max-w-sm">
        <DialogTitle>Cantidad de personas</DialogTitle>
        <div className="space-y-4">
          <Input
            type="number"
            min="1"
            value={guests}
            onChange={(e) => {
              setGuests(e.target.value);
              setError("");
            }}
            placeholder="Ej: 4"
            className="h-10"
            autoFocus
            disabled={isLoading}
          />
          {error && <p className="text-sm text-red-600">{error}</p>}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
            Cancelar
          </Button>
          <Button onClick={handleConfirm} disabled={!guests.trim() || isLoading}>
            Continuar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
